
import React from 'react';
const CreditCardSelectMonth = ({ input, translate, meta: { touched, error, warning, asyncValidating } }) => {
  return(
    <div>
      <select {...input} className="form-control ng-pristine ng-untouched ng-valid ng-empty" size="size" ng-model="vm.cc.expiration.month" ng-init="expiration_focus=false" ng-focus="expiration_focus=true" ng-blur="expiration_focus=false">
        <option value="" hidden="hidden"> </option>
        <option value="1">01</option>
        <option value="2">02</option>
        <option value="3">03</option>
        <option value="4">04</option>
        <option value="5">05</option>
        <option value="6">06</option>
        <option value="7">07</option>
        <option value="8">08</option>
        <option value="9">09</option>
        <option value="10">10</option>
        <option value="11">11</option>
        <option value="12">12</option>
      </select>
      {touched && error && <div><span className="text-danger">{translate(error)}</span></div>}
    </div>

  )
}
export default CreditCardSelectMonth



// WEBPACK FOOTER //
// ./src/components/Payment/CreditCardSelectMonth.js